/**
 * @file
 * Floating labels script for commerce related pages.
 */

// Checkout
const $checkoutFormInputs = $('.form-item', context).filter(function() {
  return !!$(this).parents('.checkout-form').length;
});

$checkoutFormInputs.once('floating-label-checkout').each((index, el) => {
  const labels = new FloatLabels($(el)[0], {
    prefix: 'fl-',
    prioritize: 'label',
    transform: 'input, textarea',
  });
});

// Account inputs
const $accountInputs = $('.form-item', context).filter(function() {
  return !!$(this).parents(
    '.profile-customer-add-form, .dcom-user-account-form, .dcom-user-business-form, .account-order-return'
  ).length;
});

$accountInputs.once('floating-label-account').each((index, el) => {
  const labels = new FloatLabels($(el)[0], {
    prefix: 'fl-',
    prioritize: 'label',
    transform: 'input',
  });
});

// Tel fields with inputmask
const $telField = $('.js-form-type-tel', context);

$telField.once('telephone-field').each((index, el) => {
  const $this = $(el);
  const $input = $this.find('.form-tel');

  $input.on('keyup blur focus', () => {
    if ($input.val() || $input.is(':focus') || $input.is(':-webkit-autofill')) {
      $this.find('.fl-wrap').addClass('fl-is-active');
    } else {
      $this.find('.fl-wrap').removeClass('fl-is-active');
    }
  });
});
